
import { EventActions } from "./EventActions";

interface EventStatusSectionProps {
  status: string;
  archived: boolean;
  onArchiveToggle?: () => void;
}

export const EventStatusSection = ({
  status,
  archived,
  onArchiveToggle
}: EventStatusSectionProps) => {
  // If there's no archive toggle function, there's nothing to display
  if (!onArchiveToggle) {
    return null;
  }
  
  return (
    <div className="flex items-center">
      <div className="ml-auto">
        <EventActions 
          archived={archived} 
          onArchiveToggle={onArchiveToggle} 
        />
      </div>
    </div>
  );
};
